import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface RiesgosDesplazamientosPayload {
  desplazamiento_id: number;
  tipo_riesgo: string;
  descripcion: string;
  nivel_riesgo?: string | null;
  control?: string | null;
  responsable?: string | null;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface RiesgosDesplazamientos {
  id?: number;
  desplazamiento_id: number;
  tipo_riesgo: string;
  descripcion: string;
  nivel_riesgo?: string | null;
  control?: string | null;
  responsable?: string | null;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface RiesgosDesplazamientosResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class RiesgosDesplazamientosService {
  private readonly apiUrl = `${environment.apiUrl}/api/riesgos_desplazamientos`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los riesgos
   */
  getAll(): Observable<RiesgosDesplazamientos[]> {
    return this.http.get<RiesgosDesplazamientos[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener riesgo por ID
   */
  getById(id: number): Observable<RiesgosDesplazamientos> {
    return this.http.get<RiesgosDesplazamientos>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Obtener riesgos por desplazamiento
   */
  getByDesplazamiento(
    desplazamientoId: number
  ): Observable<RiesgosDesplazamientos[]> {
    return this.http.get<RiesgosDesplazamientos[]>(
      `${this.apiUrl}/desplazamiento/${desplazamientoId}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear riesgo
   */
  create(
    payload: RiesgosDesplazamientosPayload
  ): Observable<RiesgosDesplazamientosResponse> {
    return this.http.post<RiesgosDesplazamientosResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar riesgo
   */
  update(
    id: number,
    payload: Partial<RiesgosDesplazamientosPayload>
  ): Observable<RiesgosDesplazamientosResponse> {
    return this.http.put<RiesgosDesplazamientosResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar riesgo
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar riesgo
   */
  inactivar(id: number): Observable<RiesgosDesplazamientosResponse> {
    return this.http.put<RiesgosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar riesgo
   */
  activar(id: number): Observable<RiesgosDesplazamientosResponse> {
    return this.http.put<RiesgosDesplazamientosResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}